import CustomDirectionsRenderer from './custom-directions-renderer'
import iconArrowStart from '@/public/assets/svg/arrow-start.svg'

const createAdvanceMarkerElement = (content: string, rotation: number = 0, padding: string | number = '0', style?: { [key: string]: any }) => {
  if (typeof padding === 'number') {
    padding = padding.toString()
  }
  const tempEl = document.createElement('div')
  const tempContentEl = document.createElement('div')
  tempEl.style.position = 'relative'
  tempEl.style.top = '5px'
  tempEl.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width=50 height=50 fill="#FFF" style="position: relative; z-index: 2" viewBox="0 0 100 80" enable-background="new 0 0 100 100" xml:space="preserve"><defs><filter id="f1" x="0" y="0" width="200%" height="200%"><feOffset result="offOut" in="SourceAlpha" dx="0" dy="0" /><feGaussianBlur result="blurOut" in="offOut" stdDeviation="3" /><feBlend in="SourceGraphic" in2="blurOut" mode="normal" /></filter></defs><path d="M81.588,40.323C81.556,22.995,67.481,8.972,50.153,9.005C32.825,9.039,18.805,23.113,18.836,40.441  c0.012,6.01,1.829,11.548,4.65,16.384C29.86,67.748,50.31,91.877,50.31,91.877s20.64-24.564,26.923-35.545  C79.938,51.6,81.601,46.167,81.588,40.323z M50.166,16.251c13.33-0.026,24.152,10.759,24.178,24.086  c0.025,13.326-10.757,24.152-24.088,24.179c-13.324,0.022-24.148-10.761-24.174-24.088C26.056,27.101,36.838,16.275,50.166,16.251z" filter="url(#f1)"/></svg>'
  tempContentEl.innerHTML = content
  tempContentEl.style.position = 'absolute'
  tempContentEl.style.display = 'flex'
  tempContentEl.style.alignItems = 'center'
  tempContentEl.style.justifyContent = 'center'
  tempContentEl.style.top = '10px'
  tempContentEl.style.left = '10px'
  tempContentEl.style.zIndex = style?.zIndex || '1'
  tempContentEl.style.backgroundColor = style?.backgroundColor || '#0284c7'
  tempContentEl.style.color = style?.color || '#FFF'
  tempContentEl.style.fontWeight = 'bold'
  tempContentEl.style.border = 'none'
  tempContentEl.style.borderRadius = '9999px'
  tempContentEl.style.padding = padding
  tempContentEl.style.width = '30px'
  tempContentEl.style.height = '30px'
  tempEl.appendChild(tempContentEl)
  if (rotation !== 0) {
    tempEl.style.transform = `rotate(${rotation}deg)`
    tempEl.style.transformOrigin = 'bottom'
  }
  return tempEl
}

const createStartMarkerElement = (rotation: number = 0, padding: string = '0', style?: { [key: string]: any }) => {
  const tempEl = document.createElement('div')
  tempEl.style.position = 'relative'
  tempEl.style.top = '-8px'
  tempEl.innerHTML = `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.5" cy="15.5" r="14.2"
      fill="white" stroke="#1F74D7" stroke-width="2"/>
    <g clip-path="url(#clip0_1126_7332)">
      <path d="M10.2375 16.8156L17.8358 9.3924L16.659 19.9496L14.3885 16.4561L10.2375 16.8156Z" fill="#1F74D7" stroke="#1F74D7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1126_7332">
        <rect width="15.6" height="15.6" fill="white" transform="translate(5.3562 12.3105) rotate(-18.986)"/>
      </clipPath>
    </defs>
  </svg> `

  if (rotation !== 0) {
    tempEl.style.transform = `rotate(${rotation}deg)`
    tempEl.style.transformOrigin = 'bottom'
  }
  return tempEl
}

const createAdvanceMarkerVehicleInStage = () => {
  const tempEl = document.createElement('div')
  tempEl.style.position = 'relative'
  tempEl.style.top = '15px'
  tempEl.innerHTML = `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.5" cy="15.5" r="14.2"
      fill="white" stroke="#1F74D7" stroke-width="2"/>
  </svg>`
  return tempEl
}

export default (initMap?: null | google.maps.Map) => {
  let map: null | google.maps.Map = initMap === undefined ? null : initMap
  let emits: any
  const directionsRenderer = ref<google.maps.DirectionsRenderer>()
  let polylineRenderers: google.maps.Polyline[] = []
  const directionsRenderers = ref<CustomDirectionsRenderer[]>([])
  const directionsService = ref<google.maps.DirectionsService>()
  const directionMarkers = ref<google.maps.marker.AdvancedMarkerElement[]>([])
  const markerDirection: Array<any> = []
  const DirectionLoader = (_map: null | google.maps.Map, _emits: any) => {
    map = _map
    emits = _emits
  }

  const drawDirection = (
    origin: google.maps.LatLng | google.maps.LatLngLiteral,
    destination: google.maps.LatLng | google.maps.LatLngLiteral,
    travelMode: string = 'DRIVING',
    waypoints: any[] = [],
    options?: {
      originLocationName?: string
      destinationLocationName?: string
      sameOriginDestination?: boolean
      renderMarkerByIndexNumber?: boolean
      multiple?: boolean
      draggable?: boolean
      data?: any
      polylineStyle?: { [key: string]: any }
      startMarker?: boolean
      noMarker?: boolean
    }
  ) => {
    if (!map) {
      return
    }
    if (!directionsService.value) {
      return
    }
    const request = {
      origin,
      destination,
      waypoints: waypoints.map(({ location }) => ({
        location
      })),
      optimizeWaypoints: true,
      travelMode
    } as google.maps.DirectionsRequest

    const multiple = !!options?.multiple
    const startMarker = !!options?.startMarker
    const polylineStyle = options?.polylineStyle || $map.polylineStyle.routeActual

    if (!multiple) {
      clearDirections()
      clearPolyline()
    }

    directionsService.value.route(request).then((response: any) => {
      if (!map || !directionsRenderer.value) {
        return
      }

      if (multiple) {
        const d = new google.maps.DirectionsRenderer()

        d.setMap(map)

        d.setOptions({
          suppressMarkers: true,
          draggable: !!options?.draggable,
          polylineOptions: polylineStyle
        })
        d.setDirections(response)

        if (startMarker) {
          // Thêm icon tuỳ chỉnh vào điểm bắt đầu
          createStartMarker(response)
        }

        const customRenderer = new CustomDirectionsRenderer(Math.random().toString(36).substr(2, 9), d, options?.data || {})

        customRenderer.renderer.addListener(
          'directions_changed',
          customRenderer.setDirectionsChangedListener(() => {
            updateDirectionsRenderers(directionsRenderers.value)
          })
        )

        directionsRenderers.value.push(customRenderer)

        updateDirectionsRenderers(directionsRenderers.value)
      } else {
        directionsRenderer.value.setDirections(response)
        directionsRenderer.value.setOptions({ draggable: !!options?.draggable, polylineOptions: polylineStyle, suppressMarkers: true })

        if (options?.noMarker) {
          return
        }
        generateDirectionMarkers(
          {
            location: origin,
            name: options?.originLocationName
          },
          {
            location: destination,
            name: options?.destinationLocationName
          },
          waypoints,
          {
            sameOriginDestination: !!options?.sameOriginDestination,
            renderMarkerByIndexNumber: !!options?.renderMarkerByIndexNumber
          }
        )
      }
    })
  }

  const updateDirectionsRenderers = $lodash.debounce((data: any) => {
    emits('updateDirections', data)
  }, 100)

  const generateDirectionMarkers = (
    origin: { location: { [key: string]: any }; name?: string },
    destination: { location: { [key: string]: any }; name?: string },
    waypoints: any[] = [],
    options: { [key: string]: any }
  ) => {
    if (!map) {
      return
    }

    const tmpWaypoints = $lodash.cloneDeep(waypoints)
    tmpWaypoints.unshift(origin)
    tmpWaypoints.push(destination)
    const sameIndexes: any[] = []
    tmpWaypoints.forEach(({ location }: any, i: number) => {
      if (location?.lng && location?.lat) {
        for (let j = i + 1; j < tmpWaypoints.length; j++) {
          const wp2 = tmpWaypoints[j]
          if (!wp2 || !wp2.location) {
            continue
          }
          const wp2Location = wp2.location
          if (wp2Location.lng === location.lng && wp2Location.lat === location.lat) {
            const exists = sameIndexes.findIndex((sameArr: number[]) => sameArr.includes(i) || sameArr.includes(j))
            if (exists >= 0) {
              if (!sameIndexes[exists].includes(j)) {
                sameIndexes[exists].push(j)
              }
            } else {
              sameIndexes.push([i, j])
            }
          }
        }
      }
    })

    const { sameOriginDestination, renderMarkerByIndexNumber } = options
    const stepDisplay = new google.maps.InfoWindow()

    // Clear marker
    directionMarkers.value.forEach((marker) => {
      marker.map = null
    })
    directionMarkers.value = []
    const markerArray: any[] = []
    const zIndex = 100

    const sameNodes: { [key: string]: any[] } = {}
    for (let index = 0; index <= tmpWaypoints.length - 1; index++) {
      const tempSame = sameIndexes.find((sa: number[]) => sa.includes(index))
      let tmpRadius: number = 0
      if (tempSame) {
        const tmpInd = tempSame.findIndex((s: number) => s === index)
        const tmpMed = Math.round(tempSame.length / 2)
        if (tempSame.length % 2 === 0) {
          if (tmpInd < tmpMed) {
            tmpRadius = (tmpMed - tmpInd) * -60 + 30
          } else {
            tmpRadius = (tmpInd + 1 - tmpMed) * 60 - 30
          }
        } else if (tmpInd < tmpMed - 1) {
          tmpRadius = (tmpMed - 1 - tmpInd) * -60
        } else if (tmpInd > tmpMed - 1) {
          tmpRadius = (tmpInd + 1 - tmpMed) * 60
        }
      }
      const { location, node, locationName } = tmpWaypoints[index]

      if (location?.options?.vehicleInStage) {
        const vehicleInStageMarker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position: location as google.maps.LatLng,
          content: createAdvanceMarkerVehicleInStage(),
          zIndex
        })
      }

      const tempMarker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: location,
        zIndex
      })
      tempMarker.position = location
      if (node && typeof node === 'string') {
        if (Array.isArray(sameNodes[node])) {
          sameNodes[node].push(index)
        } else {
          sameNodes[node] = []
        }
      }
      directionMarkers.value.push(tempMarker)
      markerArray.push({
        marker: tempMarker,
        position: index === 0 ? 'origin' : index === tmpWaypoints.length - 1 ? 'destination' : index,
        node,
        name: locationName,
        radius: tmpRadius
      })
    }

    const baseRotation = 20
    for (let i = 0; i < markerArray.length; i++) {
      const markerRadius = markerArray[i].radius
      if (i === 0) {
        if (origin.location?.options?.vehicleInStage) {
          const vehicleInStageMarker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: origin.location as google.maps.LatLng,
            content: createAdvanceMarkerVehicleInStage(),
            zIndex
          })
        }

        const originMarker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position: origin.location as google.maps.LatLng,
          content: createAdvanceMarkerByType(renderMarkerByIndexNumber ? '1' : 'start', markerRadius),
          zIndex: 999
        })
        attachMarkerInfo(stepDisplay, originMarker, origin.name || 'A', map)
        directionMarkers.value.push(originMarker)
        continue
      }
      if (i === markerArray.length - 1) {
        if (destination.location?.options?.vehicleInStage) {
          const vehicleInStageMarker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: destination.location as google.maps.LatLng,
            content: createAdvanceMarkerVehicleInStage(),
            zIndex
          })
        }

        const destinationMarker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position: destination.location as google.maps.LatLng,
          content: createAdvanceMarkerByType(renderMarkerByIndexNumber ? (1 + waypoints.length + 1).toString() : 'end', markerRadius),
          zIndex: 999
        })
        attachMarkerInfo(stepDisplay, destinationMarker, destination.name || 'B', map)

        directionMarkers.value.push(destinationMarker)
        continue
      }

      const marker = markerArray[i].marker
      const tempNode = markerArray[i].node
      const tempPosition = markerArray[i].position
      let rotation: number = 0
      if (typeof tempNode === 'string' && sameNodes[tempNode].length > 1) {
        const tempIndex = sameNodes[tempNode].findIndex((n: string | number) => n === tempPosition)
        rotation = tempIndex * ((baseRotation * sameNodes[tempNode].length) / sameNodes[tempNode].length) - (baseRotation * sameNodes[tempNode].length) / 2
      }

      marker.content = createAdvanceMarkerByType(renderMarkerByIndexNumber ? (i + 1).toString() : i.toString(), markerRadius)

      attachMarkerInfo(stepDisplay, marker, markerArray[i].name || renderMarkerByIndexNumber ? (i + 1).toString() : i.toString(), map)
    }
  }

  const attachMarkerInfo = (
    stepDisplay: google.maps.InfoWindow,
    marker: google.maps.Marker | google.maps.marker.AdvancedMarkerElement,
    text: string,
    map: google.maps.Map
  ) => {
    google.maps.event.addListener(marker, 'click', () => {
      stepDisplay.setContent(text)
      stepDisplay.open(map, marker)
    })
  }

  const createStartMarker = (response: any) => {
    const leg = response.routes[0].legs[0]
    const firstStep = leg.steps[0]
    const startLocation = firstStep.start_point
    const nextLocation = firstStep.end_point

    // Tính toán góc
    const angle = Math.atan2(nextLocation.lng() - startLocation.lng(), nextLocation.lat() - startLocation.lat())

    const zIndex = 100
    const originMarker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: {
        lat: startLocation.lat(),
        lng: startLocation.lng()
      },
      content: createStartMarkerElement((((angle * 180) / Math.PI + 360) % 360) - 18.986),
      zIndex
    })
  }

  const clearDirection = () => {
    directionsRenderer.value && directionsRenderer.value.setMap(null)
  }

  const clearDirections = () => {
    ; (directionsRenderers.value || []).forEach((item: any) => {
      item?.renderer?.setMap(null)
    })
    directionsRenderers.value = []
  }

  const drawDirectionMultiple = async (data: any[], travelMode?: string) => {
    if (!map || !Array.isArray(data)) {
      return
    }
    const directions = []
    for (let i = 0; i < data.length - 1; i++) {
      const direction = await drawDirection(data[i], data[i + 1], travelMode)
      directions.push(direction)
    }

    return directions
  }

  const drawPolyline = (data: any, options?: { [key: string]: any }) => {
    if (!map) {
      return
    }
    const bounds = new google.maps.LatLngBounds()
    data.forEach((item: any) => {
      bounds.extend(item)
    })

    const polylineStyle = options?.polylineStyle || $map.polylineStyle.routeActual

    const polyline = new google.maps.Polyline()
    polyline.setOptions({
      path: data,
      geodesic: true,
      ...polylineStyle
    })
    polyline.setMap(map)

    map.fitBounds(bounds)
    if (!options?.noSave) {
      polylineRenderers?.push(polyline)
    }
    return polyline
  }

  const clearPolyline = () => {
    for (let i = 0; i < polylineRenderers.length; i++) {
      polylineRenderers[i].setMap(null)
    }
    polylineRenderers = []
  }

  const clearRouting = () => {
    for (let i = 0; i < markerDirection.length; i++) {
      markerDirection[i].setMap(null)
    }
    emits && emits('dataInformation', null, null)
  }

  const resetMap = () => {
    directionsRenderer.value && directionsRenderer.value.setMap(map)
  }

  // type: start, end or index
  const createAdvanceMarkerByType = (type: string, rotation: number = 0) => {
    if (type === 'start') {
      return createAdvanceMarkerElement(
        `<svg width="16" height="16" fill="#FFF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115.4 122.88">
  <path
    d="M24.94,67.88A14.66,14.66,0,0,1,4.38,47L47.83,4.21a14.66,14.66,0,0,1,20.56,0L111,46.15A14.66,14.66,0,0,1,90.46,67.06l-18-17.69-.29,59.17c-.1,19.28-29.42,19-29.33-.25L43.14,50,24.94,67.88Z" />
</svg>`,
        rotation,
        undefined,
        { backgroundColor: '#3099b8' }
      )
    }

    if (type === 'end') {
      return createAdvanceMarkerElement(
        `<svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
           <ellipse cx="3.03319" cy="3.36437" rx="2.52245" ry="2.61047" fill="#D9D9D9"/>
        </svg>`,
        rotation,
        undefined,
        {
          backgroundColor: '#d11302',
          color: '#d11302'
        }
      )
    }

    return createAdvanceMarkerElement(type, rotation)
  }

  const getDirection = async (
    origin: google.maps.LatLng | google.maps.LatLngLiteral,
    destination: google.maps.LatLng | google.maps.LatLngLiteral,
    options?: any
  ) => {
    if (!directionsService.value) {
      directionsService.value = new google.maps.DirectionsService()
    }
    const travelMode = options?.travelMode || 'DRIVING'
    const waypoints: any[] = options?.waypoints || []
    const request = {
      origin,
      destination,
      waypoints: waypoints.map(({ location }: any) => ({
        location
      })),
      optimizeWaypoints: true,
      travelMode
    } as google.maps.DirectionsRequest

    return await directionsService.value.route(request)
  }

  const customDirections = ref<any[]>([])
  const drawCustomDirection = (
    origin: google.maps.LatLng | google.maps.LatLngLiteral,
    destination: google.maps.LatLng | google.maps.LatLngLiteral,
    options?: any
  ) => {
    const polylineStyle = options?.polylineStyle || $map.polylineStyle.routeActual
    getDirection(origin, destination, options).then((response: any) => {
      if (!response) {
        return
      }
      const d = new google.maps.DirectionsRenderer()
      customDirections.value.push(d)
      d.setMap(map)
      d.setDirections(response)
      d.setOptions({ polylineOptions: polylineStyle, suppressMarkers: true })
    })
  }

  const clearCustomDirections = () => {
    customDirections.value.forEach((d: any) => {
      d?.setMap(null)
    })
  }

  return {
    directionsRenderer,
    directionsRenderers,
    directionsService,
    directionMarkers,
    markerDirection,
    DirectionLoader,
    drawDirection,
    drawDirectionMultiple,
    clearDirections,
    clearDirection,
    drawPolyline,
    clearPolyline,
    clearRouting,
    resetMap,
    generateDirectionMarkers,
    polylineRenderers,
    getDirection,
    drawCustomDirection,
    clearCustomDirections
  }
}
